export const DEFAULT_SWAP_OPTIONS = {
  input: {},
};
